import { useRef, useState } from "react";
import { Download, Music } from "lucide-react";
import { useInView } from "./useInView";
import { Lyrics, activeLine } from "./Lyrics";

const AUDIO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_mon-site-web-116--9wlowa4k/artifacts/078f62d913401e6f_AUDIO-2026-10-30-12-33-58.mp3";

export const Chanson = () => {
  const [ref, cls] = useInView(0.15);
  const audioRef = useRef(null);
  const [current, setCurrent] = useState(-1);

  const onTime = () => {
    const i = activeLine(audioRef.current.currentTime);
    if (i !== current) setCurrent(i);
  };
  const seek = (s) => {
    const a = audioRef.current;
    a.currentTime = s;
    a.play().catch(() => {});
  };

  return (
    <section id="chanson" ref={ref} className={`bg-mm-paper text-mm-ink py-24 md:py-32 border-t border-mm-ink/10 ${cls}`} data-testid="chanson-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr] gap-12">
        <p className="mm-lab text-mm-golddark">La chanson</p>
        <div className="min-w-0 grid lg:grid-cols-[1fr_1fr] gap-12 items-start">
          <div className="reveal lg:sticky lg:top-24">
            <h2 className="disp mm-h2">Pose la question</h2>
            <p className="mm-body mt-4 max-w-md">La Grande Question, en musique. Écoutez, et suivez les paroles en même temps.</p>
            <div className="mt-8 bg-mm-ink text-mm-paper p-6">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 bg-mm-red flex items-center justify-center shrink-0"><Music className="w-6 h-6" /></span>
                <div>
                  <p className="disp text-xl">MM4S · La Grande Question</p>
                  <p className="text-sm text-mm-cream">Chanson · environ 3 min 14</p>
                </div>
              </div>
              <audio ref={audioRef} controls preload="metadata" src={AUDIO_URL} onTimeUpdate={onTime} onSeeked={onTime}
                className="w-full mt-6" data-testid="chanson-audio">
                Votre navigateur ne peut pas lire ce fichier audio.
              </audio>
              <a href={AUDIO_URL} target="_blank" rel="noopener noreferrer" download data-testid="chanson-download" className="mt-5 inline-flex items-center gap-2 text-sm font-bold ulink">
                <Download className="w-4 h-4" /> Télécharger le MP3
              </a>
            </div>
          </div>
          <Lyrics current={current} onSeek={seek} />
        </div>
      </div>
    </section>
  );
};
